



export class SelectItem
{

	public rowKey: number;

                                      public value: any;

                                          public label: string;


constructor() {

                                                                                                                                                                                                                this.value = null; // any

                                                                                                                                                                                                                    this.label = ''; // string

    

}

}
